import { ElioError } from '@elio/shared/models';
import { createAction, props } from '@ngrx/store';
import { Offer } from '../../model/src/lib/offer.model';

const loadOffer = createAction('[Current Offer Effect] Load offer', props<{ offerId: number }>());
const loadOfferSuccess = createAction('[Current Offer Effect] Load offer SUCCESS', props<{ offer: Offer }>());
const loadOfferFailure = createAction('[Current Offer Effect] Load offer FAILURE', props<{ error: ElioError }>());
const navigateToOffer = createAction('[Current Offer Effect] Navigate to offer');

export const CurrentOfferEffectActions = {
  navigateToOffer,
  loadOffer,
  loadOfferSuccess,
  loadOfferFailure,
};
